<template>
    <a-card>
      
      <h3 style="text-align: center;margin:20px 0 40px">研究人员信息</h3>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #researchersType="{text}">
                <dict-render :dict-obj="dictObjs['researchersType']" :text="text"></dict-render>
            </template>
            <template #academicDegree="{text}">
                <dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
            </template>
                <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddProjectResearchers ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
  </template>
  
  <script>
  import store from '@/store';
  import AddProjectResearchers from "./components/AddProjectResearchers";
  import {tableListMixin,dictMixin} from "@/mixins";
  import {projectResearchers} from "@/api/TechnologieprojekteApply";
import DictRender from "@/components/other/DictRender";
  
  const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "项目负责人类型", dataIndex: "researchersType", key: "researchersType", slots: {customRender: "researchersType"}},
    {title: "姓名", dataIndex: "name", key: "name"},
    {title: "学位（最高学历学位）", dataIndex: "academicDegree", key: "academicDegree", slots: {customRender: "academicDegree"}},
    {title: "承担任务", dataIndex: "undertakeTasks", key: "undertakeTasks"},
    {title: "单位", dataIndex: "workUnit", key: "workUnit"},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
  ];
  export default {
    name: "研究人员信息",
    mixins: [tableListMixin,dictMixin],
    components: {
        DictRender,
        AddProjectResearchers
    },
    data() {
        return {
            dictNames: 'researchersType,education_background',
            columns,
            queryParam: {projectId: store.getters.TechnologieTypeId.projectId,classification: store.getters.TechnologieTypeId.classification},
            listUrl: projectResearchers.pageList,
            listKeyField: "id",
            deleteUrl: projectResearchers.remove
        }
    },
    methods: {
        onAdd() {
            this.$refs.modal.postForm(store.getters.TechnologieTypeId.projectId,store.getters.TechnologieTypeId.classification)
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: projectResearchers.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  